function ngLocaleRoot() {
  var lang = (document.documentElement.lang || "da").toLowerCase().split("-")[0];
  if (lang === "da") return "/da-dk/";
  return "/" + lang + "/";
}
/**
 * Nordele Gastro — QuickView & AJAX Add-to-Cart
 * Vanilla JS, no dependencies.
 */

// i18n helper
function ngT(key) {
  var lang = (document.documentElement.lang || "da").toLowerCase().split("-")[0];
  var d = {
    "da":{"add_to_cart":"Læg i kurv","adding":"Tilføjer...","added":"Tilføjet!"},
    "en":{"add_to_cart":"Add to cart","adding":"Adding...","added":"Added!"},
    "tr":{"add_to_cart":"Sepete ekle","adding":"Ekleniyor...","added":"Eklendi!"}
  };
  return (d[lang] && d[lang][key]) || (d.da && d.da[key]) || key;
}


(function () {
  'use strict';

  /* ── Helpers ── */

  function formatMoney(cents) {
    // Shopify money format: 1.234,56 kr. (Danish)
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var decPart = parts[1];
    return intPart + ',' + decPart + ' kr.';
  }

  function updateCartCount() {
    fetch(ngLocaleRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var counters = document.querySelectorAll('.ng-header__cart-count');
        counters.forEach(function (el) {
          el.textContent = cart.item_count;
        });
        // Update header cart total (scoped to .ng-header__cart so we don't clobber Log in link)
        var formatted = (cart.total_price / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
        document.querySelectorAll('.ng-header__cart .ng-header__account-link').forEach(function (el) {
          el.textContent = formatted;
        });
        if (window.ngCartDrawer && typeof window.ngCartDrawer.refresh === 'function') {
          window.ngCartDrawer.refresh();
        }
      })
      .catch(function () {});
  }

  function showFeedback(buttonEl, success) {
    var original = buttonEl.innerHTML;
    buttonEl.classList.add(success ? 'ng-pcard__action--success' : 'ng-pcard__action--error');
    if (success) {
      buttonEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    }
    setTimeout(function () {
      buttonEl.innerHTML = original;
      buttonEl.classList.remove('ng-pcard__action--success', 'ng-pcard__action--error');
    }, 1500);
  }

  /* ── AJAX Add to Cart ── */

  function addToCart(variantId, quantity, buttonEl) {
    if (!variantId) return;
    quantity = quantity || 1;

    if (buttonEl) buttonEl.disabled = true;

    fetch(ngLocaleRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        updateCartCount();
        if (buttonEl) {
          showFeedback(buttonEl, true);
          buttonEl.disabled = false;
        }
      })
      .catch(function () {
        if (buttonEl) {
          showFeedback(buttonEl, false);
          buttonEl.disabled = false;
        }
      });
  }

  /* ── Add-to-cart (standalone — works even without quickview) ── */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-ng-add-to-cart]');
    if (!addBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = addBtn.getAttribute('data-variant-id');
    addToCart(variantId, 1, addBtn);
  });

  /* ── QuickView Modal ── */

  var qvEl = document.getElementById('ng-quickview');
  if (!qvEl) return;

  var qvBody = qvEl.querySelector('.ng-qv__body');
  var qvLoader = qvEl.querySelector('.ng-qv__loader');
  var qvImage = qvEl.querySelector('.ng-qv__image-el');
  var qvVendor = qvEl.querySelector('.ng-qv__vendor');
  var qvTitle = qvEl.querySelector('.ng-qv__title');
  var qvPrice = qvEl.querySelector('.ng-qv__price');
  var qvSpecs = qvEl.querySelector('.ng-qv__specs');
  var qvDesc = qvEl.querySelector('.ng-qv__description');
  var qvAddBtn = qvEl.querySelector('[data-ng-qv-add-to-cart]');
  var qvFullLink = qvEl.querySelector('.ng-qv__view-full');
  var currentVariantId = null;

  function openQuickView(handle) {
    // Show modal + loader
    qvEl.classList.add('ng-qv--open');
    qvEl.setAttribute('aria-hidden', 'false');
    qvBody.style.opacity = '0';
    qvLoader.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    fetch(ngLocaleRoot() + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Product not found');
        return r.json();
      })
      .then(function (product) {
        // Image
        if (product.featured_image) {
          qvImage.src = product.featured_image;
          qvImage.alt = product.title;
          qvImage.style.display = '';
        } else {
          qvImage.style.display = 'none';
        }

        // Vendor
        qvVendor.textContent = product.vendor || '';
        qvVendor.style.display = product.vendor ? '' : 'none';

        // Title
        qvTitle.textContent = product.title;

        // Price
        var variant = product.variants[0];
        currentVariantId = variant.id;
        var priceHtml = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var savePct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          priceHtml = '<span class="ng-qv__price--current ng-qv__price--onsale">' + formatMoney(variant.price) + '</span>';
          priceHtml += ' <span class="ng-qv__price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
          priceHtml += ' <span class="ng-qv__price--save">SPAR ' + savePct + '%</span>';
        } else {
          priceHtml = '<span class="ng-qv__price--current">' + formatMoney(variant.price) + '</span>';
        }
        qvPrice.innerHTML = priceHtml;

        // Specs — check metafields (not available via .js, so we'll build from tags or leave empty)
        // The product.js endpoint does not include metafields; specs are shown on the card via Liquid.
        qvSpecs.innerHTML = '';
        qvSpecs.style.display = 'none';

        // Description (truncated)
        if (product.description) {
          // Strip HTML and truncate
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = product.description;
          var plainText = tempDiv.textContent || tempDiv.innerText || '';
          if (plainText.length > 200) plainText = plainText.substring(0, 200) + '...';
          qvDesc.textContent = plainText;
          qvDesc.style.display = '';
        } else {
          qvDesc.style.display = 'none';
        }

        // Full link
        qvFullLink.href = product.url;

        // Add to cart button reset
        qvAddBtn.disabled = false;
        var addBtnText = qvAddBtn.querySelector('span');
        if (addBtnText) addBtnText.textContent = ngT('add_to_cart');

        // Show content
        qvLoader.style.display = 'none';
        qvBody.style.opacity = '1';
      })
      .catch(function () {
        qvLoader.innerHTML = '<p style="color:#999;font-size:14px;">' + ngT('Could not load product.', 'Ürün yüklenemedi.', 'Kunne ikke indlæse produkt.') + '</p>';
      });
  }

  function closeQuickView() {
    qvEl.classList.remove('ng-qv--open');
    qvEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    currentVariantId = null;
  }

  /* ── Event Delegation ── */

  document.addEventListener('click', function (e) {
    // QuickView open
    var qvTrigger = e.target.closest('[data-ng-quickview]');
    if (qvTrigger) {
      e.preventDefault();
      e.stopPropagation();
      var handle = qvTrigger.getAttribute('data-handle');
      if (handle) openQuickView(handle);
      return;
    }

    // QuickView close
    var closeTrigger = e.target.closest('[data-ng-qv-close]');
    if (closeTrigger) {
      e.preventDefault();
      closeQuickView();
      return;
    }


    // QuickView add-to-cart
    var qvAddTrigger = e.target.closest('[data-ng-qv-add-to-cart]');
    if (qvAddTrigger && currentVariantId) {
      e.preventDefault();
      qvAddTrigger.disabled = true;
      var btnText = qvAddTrigger.querySelector('span');
      if (btnText) btnText.textContent = ngT('adding');

      addToCart(currentVariantId, 1, null);

      // Show success after short delay
      setTimeout(function () {
        if (btnText) btnText.textContent = ngT('added');
        qvAddTrigger.classList.add('ng-qv__add-to-cart--success');
        setTimeout(function () {
          if (btnText) btnText.textContent = ngT('add_to_cart');
          qvAddTrigger.disabled = false;
          qvAddTrigger.classList.remove('ng-qv__add-to-cart--success');
        }, 1500);
      }, 600);
      return;
    }
  });

  // Escape key closes QuickView
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && qvEl.classList.contains('ng-qv--open')) {
      closeQuickView();
    }
  });

})();
